if (!customElements.get('visual-navigation-swiper')) {
  class VisualNavigationSwiper extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.options = {};
    }

    // Method to initialize the Swiper slider if present
    initSlider() {
      if (!this.querySelector('[data-slider]')) return; // Exit if no slider element is found

      const totalSlides = this.querySelectorAll('.swiper-slide');
      // Configure Swiper options
      this.options = {
        slidesPerView: 'auto', // Show as many slides as fit within the container
        spaceBetween: 5,
        navigation: {
          prevEl: this.querySelector('.swiper-button-prev'),
          nextEl: this.querySelector('.swiper-button-next'),
        },
        breakpoints: {
          750: {
            slidesPerView: 5,
            spaceBetween: 5,
          },
          1024: {
            slidesPerView: 7,
            spaceBetween: 8,
          },
          1200: {
            slidesPerView: 9,
            spaceBetween: 8,
          }
        },
        on: {
          init: function () {
            updateAriaAttributes();
          },
          slideChange: function () {
            updateAriaAttributes();
          },
        }
      };

      function updateAriaAttributes() {
        totalSlides.forEach((slide) => {
          const ariaLabel = slide.getAttribute("aria-label").replace("Slide ", "");
          slide.setAttribute("aria-label", `Slide ${ariaLabel}`);

          setTimeout(() => {
            let isActive = slide.classList.length > 1;

            if (isActive) {
              slide.setAttribute("aria-hidden", "false");
              slide.querySelectorAll("a, button, input, textarea, select").forEach(el => {
                el.setAttribute("tabindex", "0");
              });
            } else {
              slide.setAttribute("aria-hidden", "true");
              slide.querySelectorAll("a, button, input, textarea, select").forEach(el => {
                el.setAttribute("tabindex", "-1");
              });
            }
          }, 200);
        });
      }

      // Initialize the Swiper slider
      this.slider = new Swiper(
        this.querySelector('[data-slider]'), // Pass the slider element
        this.options, // Pass the configuration options
      );
    }

    scrollToActiveLink() {
      const activeSlide = this.querySelector('.active__slide');
      if (!activeSlide) return; // Exit if no active link is found

      this.slider.slideTo(Array.from(this.querySelectorAll('.swiper-slide')).indexOf(activeSlide), 500, false);
    }

    connectedCallback() {
      this.initSlider();

      this.scrollToActiveLink(); // Scroll to the active link on initial load
    }
  }
  customElements.define('visual-navigation-swiper', VisualNavigationSwiper);
}